function autofill() {

    if (devmode) {
        $('body').append('<a class="autofiller right hide">Autofill</a>');

        $('.autofiller').on('click', function(){

            var randomer = Math.floor((Math.random() * 1000) + 1);

            $('#signup-form input#firstname').val('John');
            $('#signup-form input#lastname').val('Doe');
            $('#signup-form input#password').val('testertest');
            $('#signup-form input#email').val('gg+'+randomer+'@ultra.us');
            $('#signup-form select#birthyear').val('1980');
            $('#signup-form select#birthmonth').val('04');
            $('#signup-form select#birthday').val('24');
            $('#signup-form select#country').val('US');
            $('#signup-form select#homeevent').val('miami');
            $('#signup-form select#homeevent-signup').val('miami');
            $('#signup-form input.male').prop('checked', true);
            $('#signup-form input#accept_terms').prop('checked', true);

        })

    //setTimeout(function() { $('.autofiller').trigger('click'); }, 500)

}

}
